<div class="button-menu">
  @if (customPresets.length || !currentPreset) {
    <h3 class="menu-list-title">STANDARD</h3>
  }
  @for (preset of standardPresets; track preset) {
    <app-button-menu-item
      name="apply-preset"
      location="gallery-settings-presets-context"
      [color]="currentPreset === preset ? 'simple-primary' : 'simple'"
      [attr.data-test-id]="'preset-' + preset.name"
      icon="toggle"
      [fullWidth]="true"
      (click)="applyPreset.emit(preset); onClose.emit()"
    >
      <div class="preset-name">
        <span>{{ preset.name }}</span>
        @if (currentPreset === preset) {
          <app-svg src="/assets/icons/check.svg"></app-svg>
        }
      </div>
    </app-button-menu-item>
  }
  @if (customPresets.length || !currentPreset) {
    <div class="divider"></div>
    <h3 class="menu-list-title custom">CUSTOM</h3>
    @for (preset of customPresets; track preset) {
      <app-button-menu-item
        name="apply-preset"
        location="gallery-settings-presets-context"
        [color]="currentPreset === preset ? 'simple-primary' : 'simple'"
        icon="gear-bg"
        [fullWidth]="true"
        (click)="applyPreset.emit(preset); onClose.emit()"
      >
        <div class="preset-name">
          <span>{{ preset.name }}</span>
          @if (currentPreset === preset) {
            <app-svg src="/assets/icons/check.svg"> </app-svg>
          }
        </div>
      </app-button-menu-item>
    }
    @if (!currentPreset) {
      <app-button-menu-item
        name="save-custom-preset"
        location="gallery-settings-presets-context"
        color="simple-primary"
        icon="plus-circle"
        data-test-id="save-custom-preset"
        (click)="createPreset.emit(); onClose.emit()"
        [fullWidth]="true"
      >
        Save Custom Preset
        @if (!('gallery:custom-presets' | billingScope: gallery)) {
          <app-pro-tag
            location="gallery-settings-presets-context"
            scope="gallery:custom-presets"
            [tenantId]="gallery?.['tenant']?.['id'] || gallery?.['tenant']"
            [noTop]="true"
          ></app-pro-tag>
        }
      </app-button-menu-item>
    }
  }
</div>
